export function reverse(str: string): string {
	return str.split('').reverse().join('');
}
